import { WorkloadAdjustment, WorkloadAdjustmentRequest } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function adjustWorkload(httpClient: HttpClient) {
  return (request: WorkloadAdjustmentRequest) =>
    httpClient.sendHttpRequest<WorkloadAdjustment>({
      endpoint: "/capacity-planning/workload",
      method: HttpMethods.PUT,
      data: {
        resourceId: request.resourceId,
        projectId: request.projectId,
        from: request.from,
        to: request.to,
        granularity: request.granularity,
        value: request.value,
      },
    });
}

export { adjustWorkload };
